import React from 'react';

import LoadingBigIcon from 'app/components/LoadingBigIcon';


export default function LoadingPage() {
    return (
        <section className="ny__set first-set  ">
            <div className="ny__set__desc-container content-container">
                <div className="ny__set__title-loading">
                    <LoadingBigIcon />
                </div>
            </div>
        </section>
    );
}
